export const dataWarehouse = {
  input: {
    dataSet: "DataSet",
    getData: "Get data",
    getDataSuccess: "DataSet succesfully read"
  }
};
